import BaseService from "../config/baseService";
import axios from "axios";
import {
  API_GET_AUTOHUB_SERVICE_CATEGORIES,
  API_GET_CATEGORIZED_OFFERS,
  API_GET_OFFERS
} from "../config/webService";

class CampaignService extends BaseService {
  #request = async (options) => {
    const result = await axios(options);
    return result?.data?.response;
  };

  async getCampaign(slug) {
    return await this.#request({
      url: API_GET_OFFERS,
      method: "GET",
      params: {
        slug
      }
    });
  }

  async getCategorizedCampaign({ pageIndex, pageSize, categoryId, isPackages }) {
    return await this.#request({
      url: API_GET_CATEGORIZED_OFFERS,
      method: "GET",
      params: {
        pageIndex: Number(pageIndex),
        pageSize: Number(pageSize),
        categoryId,
        isPackage: isPackages
      }
    });
  }

  async getServiceCategorizes({ isPrePaid }) {
    return await this.#request({
      url: API_GET_AUTOHUB_SERVICE_CATEGORIES,
      method: "GET",
      params: {
        forCMS: false,
        isPrePaid
      }
    });
  }
}

export default new CampaignService();
